import React, { useEffect, useState } from "react";
import { useIntegrationApp } from "@integration-app/react";
import { Connection } from "@integration-app/sdk";
import IntegrationCard from "./integration_card";
import { DISPLAY_NOTIFICATION, notificationEventBus } from "app/notificationsEventBus";

const supportedIntegrationAppIntegrations = [
  {
    key: "zephyr-scale",
    name: "Zephyr Scale",
  },
  {
    key: "zephyr-squad-legacy",
    name: "Zephyr Squad",
  },
];

const IntegrationAppIntegrations = () => {
  const [connections, setConnections] = useState<Connection[]>([]);
  const integrationApp = useIntegrationApp();

  const fetchConnections = () => {
    integrationApp.connections
      .find()
      .then(response => {
        setConnections(response.items);
      })
      .catch(() => {
        notificationEventBus.dispatch(DISPLAY_NOTIFICATION, {
          type: "danger",
          message: "There was an issue with connecting to some integrations, please try again later.",
        });
      });
  };

  useEffect(() => {
    fetchConnections();
  }, []);

  const integrationsList = supportedIntegrationAppIntegrations.map(integration => ({
    name: integration.name,
    key: integration.key,
    active: connections.some(connection => connection?.integration?.key === integration.key),
  }));

  const resetConnection = (integrationKey: string) => {
    integrationApp
      .connection(integrationKey)
      .archive()
      .then(() => fetchConnections());
  };

  const createConnection = (integrationKey: string) => {
    integrationApp
      .integration(integrationKey)
      .openNewConnection()
      .then(() => fetchConnections());
  };

  return (
    <div className="row">
      {integrationsList.map(integration => (
        <div className="col-lg-4 col-sm-6" key={integration.key}>
          <IntegrationCard
            createConnection={createConnection}
            resetConnection={resetConnection}
            integration={integration}
          />
        </div>
      ))}
    </div>
  );
};

export default IntegrationAppIntegrations;
